import React from 'react';
import { useIntl } from 'react-intl';
import { WithStylesProps } from 'react-jss';

import { EM_DASH } from '~/common/constants/unicode';
import EcInput from '~/components/Shared/EcInput/EcInput';

import styles from '../InformationField.styles';
import { Field } from '../InformationFieldV2';

interface NumberFieldProps extends WithStylesProps<typeof styles> {
  field: Field;
  editMode: boolean;
  fieldValue: any;
  setFieldValue: (value: any) => void;
}

export const NumberField = ({
  classes,
  field,
  editMode,
  fieldValue,
  setFieldValue,
}: NumberFieldProps) => {
  const intl = useIntl();

  if (editMode) {
    const presentValue = fieldValue ? fieldValue.value : '';

    return (
      <div className={classes.editItemContainer}>
        <EcInput
          id={`number-field-${field.id}`}
          ariaLabel={field.name}
          input={{
            value: presentValue,
            onChange: (event: any) => {
              const newState =
                event.target.value === '' ? '' : Number(event.target.value);
              setFieldValue({ display_value: newState, value: newState });
            },
          }}
          placeholder={intl.formatMessage({
            id: 'InformationField.enterAmountPlaceholder',
            defaultMessage: 'enter amount',
            description: 'Placeholder text for number input field',
          })}
          type="number"
          width="100%"
          isDisabled={!field.is_editable}
        />
      </div>
    );
  }

  return fieldValue ? fieldValue.display_value : EM_DASH;
};
